import { AppShell } from '@/components/AppShell'
import { CommunityPage } from '@/pages/CommunityPage'
import { ContactPage } from '@/pages/ContactPage'
import { CriticalRoutePage } from '@/pages/CriticalRoutePage'
import { DonatePage } from '@/pages/DonatePage'
import { HelpPage } from '@/pages/HelpPage'
import { HomePage } from '@/pages/HomePage'
import { ResourcesPage } from '@/pages/ResourcesPage'
import { StoryPage } from '@/pages/StoryPage'

const pages = {
  home: HomePage,
  story: StoryPage,
  resources: ResourcesPage,
  help: HelpPage,
  community: CommunityPage,
  'critical-route': CriticalRoutePage,
  contact: ContactPage,
  donate: DonatePage,
}

export function App({ page = 'home' }) {
  const Page = pages[page] || HomePage

  return (
    <AppShell currentPage={page}>
      <Page />
    </AppShell>
  )
}
